import queryString from 'query-string'
import {ArFilters} from './ar.actions'

export const arPathParams = {
  query: 'query',
  verificationId: 'verificationId',
}

export const arQueryParams = {
  query: 'q',
  bookId: 'b',
  chapterId: 'c',
  paraId: 'p',
  elementId: 'e',
  filterHandbook: 'f_handbook',
  filterSkriptum: 'f_skriptum',
  filterBookTitlesOnly: 'f_book_titles_only',
  page: 'page',
}

const BASE_PATH = '/arbeitsrecht'

export const isArPath = (pathname: string): boolean => pathname.startsWith(BASE_PATH)

export const arPathOverview = () => {
  return BASE_PATH
}

export const arPathSearchSimple = (userInput: string) => {
  return `${BASE_PATH}/${userInput}`
}

const appendSearchQueryParams = (
  queryParams: {[key: string]: string | string[]},
  filters?: ArFilters,
  page?: number
) => {
  if (filters) {
    if (filters.bookTitleOnly) {
      delete queryParams[arQueryParams.filterHandbook]
      delete queryParams[arQueryParams.filterSkriptum]
      queryParams[arQueryParams.filterBookTitlesOnly] = 'true'
    }
    if (filters.handbook_name?.length) {
      queryParams[arQueryParams.filterHandbook] = filters.handbook_name
    }
    if (filters.skriptum_name?.length) {
      queryParams[arQueryParams.filterSkriptum] = filters.skriptum_name
    }
  }
  if (page) {
    queryParams[arQueryParams.page] = String(page)
  }
}

const arPath = (
  userInput: string,
  queryParams: {[p: string]: string | string[]},
  filters: ArFilters | undefined,
  page: number | undefined
) => {
  appendSearchQueryParams(queryParams, filters, page)
  const params = queryString.stringify(queryParams)
  const paramsWithSeparator = params ? `?${params}` : ''
  const userInputPathPart = userInput ? encodeURIComponent(userInput) : ''
  return `${BASE_PATH}/${userInputPathPart}${paramsWithSeparator}`
}

export const arPathSearch = (userInput: string, filters?: ArFilters, page?: number) => {
  return arPath(userInput, {}, filters, page)
}

export const arPathBook = (
  userInput: string,
  bookId: string,
  chapterId?: string,
  paraId?: string,
  filters?: ArFilters,
  page?: number,
  elementId?: string
) => {
  const queryParams: {[key: string]: string | string[]} = {}
  queryParams[arQueryParams.bookId] = bookId
  if (chapterId) {
    queryParams[arQueryParams.chapterId] = chapterId
  }
  if (paraId) {
    queryParams[arQueryParams.paraId] = paraId
  }
  if (elementId) {
    queryParams[arQueryParams.elementId] = elementId
  }
  return arPath(userInput, queryParams, filters, page)
}

export const arPathContentResources = () => {
  return `${BASE_PATH}-all`
}

export const arPathSkripten = () => {
  return `${BASE_PATH}-skripten`
}

export const arPathTrialAccount = () => {
  return `${BASE_PATH}-testzugang`
}

export const arPathAccountVerification = (verificationId: string) => {
  return `${BASE_PATH}-verifizierung/${verificationId}`
}
